export enum WidgetUIType {
  UpcomingTeams,
  RecentlyAccepted,
  RecentFormResponses,
}
